export default {"src":"/_next/static/media/fetching_quickbooks.453e59d2.svg","height":372,"width":526,"blurWidth":0,"blurHeight":0};